import React, { useState } from "react";
import Dialog from "rc-dialog";
import moment from "moment";
import axios from "axios";

import { buildCertificationTree, filterUnrelatedCertifications, removeSiblingsOfProfile } from "../../../utils/certifications";

const PassRequestModal = ({ visible, students, competenceProfile, certificates, renderCertificationNodes, onClose, refetchData, setLevelTwoPassWarning }) => {
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [showPassesCreatedMessage, setShowPassesCreatedMessage] = useState(false);

    const handleStudentChecked = (checked, uuid) => {
        if (checked) {
            setSelectedStudents([...selectedStudents, uuid]);
        } else {
            const filteredStudents = selectedStudents.filter((s) => s !== uuid);
            setSelectedStudents(filteredStudents);
        }
    };

    const handleSelectAll = () => {
        if (selectedStudents.length === students.length) {
            setSelectedStudents([]);
        } else {
            const shouldShowWarning = students?.some((student) => {
                const certificate = certificates?.find((cert) => cert.user?.uuid === student.uuid);

                if (certificate?.competence_profile?.uuid !== competenceProfile?.uuid) return true;
            });

            if (shouldShowWarning) setLevelTwoPassWarning(true);

            setSelectedStudents(students.map((s) => s.uuid));
        }
    };

    const handleSubmit = async () => {
        if (selectedStudents.length === 0) return;

        const postData = {
            certification_uuids: []
        };

        selectedStudents.forEach((uuid) => {
            const student = students.find((s) => s.uuid === uuid);

            const certificate = certificates.find((c) => c.user.uuid === student.uuid);

            if (certificate) postData.certification_uuids.push(certificate.uuid);
        });

        try {
            await axios.post("/v1/certifications/update_multiple_physical_passes/", postData);

            showPassSuccessMessage();
            refetchData();
        } catch (error) {
            console.log(error);
        }
    };

    const showPassSuccessMessage = () => {
        setShowPassesCreatedMessage(true);

        const timeout = setTimeout(() => {
            setShowPassesCreatedMessage(false);
            clearTimeout(timeout);
        }, 6000);
    };

    return (
        <Dialog
            style={{
                width: "70%",
                height: "100%",
                top: 0,
                left: 0,
                right: 0,
                margin: "70px auto",
                padding: 0
            }}
            title="Vraag pas(sen) aan"
            visible={visible}
            animation="fade"
            onClose={onClose}
        >
            {showPassesCreatedMessage && (
                <div className="alert alert-success" style={{ width: "45%" }}>
                    <p>Passen zijn aangemaakt voor de studenten die u heeft geselecteerd.</p>
                </div>
            )}
            <table className="table">
                <thead>
                    <tr>
                        <th>
                            <div>
                                <i style={{ margin: 0 }} className="fa fa-check save-all-exemptions-icon" onClick={handleSelectAll} />
                            </div>
                        </th>
                        <th>NIBHV nummer</th>
                        <th>Naam</th>
                        <th>Beschikbare certificering</th>
                    </tr>
                </thead>
                <tbody>
                    {students.map((student) => {
                        const certificate = certificates.find((cert) => cert.user.uuid === student.uuid);
                        const relatedOnly = filterUnrelatedCertifications(competenceProfile, student.available_certifications);
                        const tree = buildCertificationTree(relatedOnly);
                        const withoutSiblings = removeSiblingsOfProfile(competenceProfile, tree);

                        return (
                            <tr key={student.uuid}>
                                <td>
                                    <input
                                        onChange={(e) => {
                                            if (certificate?.competence_profile?.uuid !== competenceProfile?.uuid && e.target.checked) setLevelTwoPassWarning(true);
                                            handleStudentChecked(e.target.checked, student.uuid);
                                        }}
                                        checked={selectedStudents.includes(student.uuid)}
                                        type="checkbox"
                                        className="checkbox checkbox--no-label"
                                    />
                                </td>
                                <td>{student.nibhv_number}</td>
                                <td>
                                    <span>{student.full_name}</span>
                                    {!!certificate && (
                                        <>
                                            <div style={{ fontSize: "12px" }}>
                                                <i style={{ marginRight: "5px" }} className="fa fa-check" />
                                                {certificate.competence_profile.certification_name || certificate.competence_profile.name}
                                                {certificate.created ? ` aangemaakt op ${moment(certificate.created).format("DD-MM-YYYY")}` : null}
                                            </div>
                                        </>
                                    )}
                                </td>
                                <td>{renderCertificationNodes(withoutSiblings, student.selectedCertification, student.uuid, undefined, undefined, undefined, false)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="flex flex-justify-end">
                <button className="btn btn-primary no-sideflap" disabled={selectedStudents.length === 0} onClick={handleSubmit}>
                    Bevestigen
                </button>
            </div>
        </Dialog>
    );
};

export default PassRequestModal;
